/**
 * OpcionesProducto — "Sustitutos" colapsado (Osvaldo, Hipermaxi, 12-oct): recién al tocarlo se ven.
 * 22-oct (Elvio): el complemento ya no se esconde, sale dentro de la tarjeta (ProductCard).
 */
import { useState } from 'react'
import type { AlternativaItem, ProductCard } from '../types/product_card'
import { SubstitutesCard } from './SubstitutesCard'

interface Props {
  card: ProductCard
  onPick: (nombre: string) => void
  ocupado?: boolean
}

export function OpcionesProducto({ card, onPick, ocupado = false }: Props) {
  const [abierto, setAbierto] = useState(false)
  const subs: AlternativaItem[] = card.alternativas ?? []
  if (subs.length === 0) return null

  return (
    <div className="opciones-producto">
      <div className="opciones-botones">
        <button
          type="button"
          className={`opcion-toggle${abierto ? ' activo' : ''}`}
          aria-expanded={abierto}
          onClick={() => setAbierto(!abierto)}
        >
          Sustitutos <span className="opcion-cuenta">{subs.length}</span>
          <span aria-hidden="true" className="opcion-flecha">{abierto ? '▴' : '▾'}</span>
        </button>
      </div>
      {abierto && (
        <SubstitutesCard
          subs={subs}
          generic={card.principio_activo}
          onPick={(alt) => !ocupado && onPick(alt.nombre_comercial ?? alt.nombre ?? '')}
        />
      )}
    </div>
  )
}
